const storageCreator = (getStorage = () => {}) => {
  let innerStorage = {};

  function isSupported() {
    try {
      const testKey = '_key_for_testing_storage_api_availability_';
      getStorage().setItem(testKey, testKey);
      getStorage().removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  function getItem(name) {
    if (isSupported()) {
      return getStorage().getItem(name);
    }
    if (innerStorage.hasOwnProperty(name)) {
      return innerStorage[name];
    }
    return null;
  }

  function removeItem(name) {
    if (isSupported()) {
      getStorage().removeItem(name);
    } else {
      delete innerStorage[name];
    }
  }

  function setItem(name, value) {
    if (isSupported()) {
      getStorage().setItem(name, value);
    } else {
      innerStorage[name] = String(value);
    }
  }

  return {
    getItem,
    setItem,
    removeItem,
  };
}

export default storageCreator;
